import React, { useContext } from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import { Context } from "@components/useContext/context";
import {
  FeaturesContainer,
  Heading,
  FeaturesScrollContainer,
  FeaturesGridContainer,
  FeatureCard,
  VideoBackground,
  ImageBackground,
  CardContent,
  CardTitle,
  CardDescription
} from "./styles";
import CloneChildren from "@components/children";
import { resolvePath } from "@utils/resolvePath";

export interface IFeature {
  title: string;
  description: string;
  background: "video" | "image";
  backgroundSrc: string;
}

export interface IDashcamFeatures extends CommonProps {
  heading?: string;
  features?: IFeature[];
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const DashcamFeatures = (props: IDashcamFeatures) => {
  const { 
    heading, 
    is_visible,
    features,
    children
  } = props;
  
  const { isDesktop } = useContext(Context);
  
  const renderFeatureCard = (feature: any, index: number) => (
    <FeatureCard key={index}>
      {feature.background === "video" ? (
        <VideoBackground
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={resolvePath(feature.backgroundSrc)} type="video/mp4" />
        </VideoBackground>
      ) : (
        <ImageBackground
          src={resolvePath(feature.backgroundSrc)}
          alt={feature.title}
        />
      )}
      <CardContent>
        <CardTitle>{feature.title}</CardTitle>
        <CardDescription>{feature.description}</CardDescription>
      </CardContent>
    </FeatureCard>
  );

  return is_visible ? (
    <>
    <FeaturesContainer>
      <Heading>{heading}</Heading>
      
      {!isDesktop? (
        <FeaturesScrollContainer>
          {features?.map((feature, index) => renderFeatureCard(feature, index))}
        </FeaturesScrollContainer>
      ) : (
        <FeaturesGridContainer>
          {features?.map((feature, index) => renderFeatureCard(feature, index))}
        </FeaturesGridContainer>
      )}
    </FeaturesContainer>
    {children && <CloneChildren>{children}</CloneChildren>}
    </>
  ) : <></>;
};

export default connect(mapStateToProps)(DashcamFeatures);
